import React, { forwardRef } from 'react';
import MUIAccordionDetails, {
  AccordionDetailsProps as MUIAccordionDetailsProps,
} from '@material-ui/core/AccordionDetails';

interface AccordionDetailsProps extends MUIAccordionDetailsProps {}

const AccordionDetails = forwardRef<React.ReactElement, AccordionDetailsProps>(
  (props, ref) => {
    return <MUIAccordionDetails {...props} ref={ref} />;
  }
);

export default AccordionDetails;
